import React from 'react';
import lbPoweredby from '../../assets/images/lb-powered.png'


const PoweredByLogo = (props)=>(
    <div className="PB-logo">
        <img src={lbPoweredby} alt={"Powered By LitmusBlox"}/>
    </div>
);
export default PoweredByLogo;